<template>
  <div class="load-more">
    <slot v-if="list" :list="list" />

    <div v-if="isLoading" class="status-loading">
      <slot name="loading">
        <Loading size="sm" :theme="theme" />
        <span class="loading-text">{{ $t('loading') }}</span>
      </slot>
    </div>
    <div v-else-if="isEmpty" class="status-empty">
      <slot name="empty">
        <span>{{ $t('no-data') }}</span>
      </slot>
    </div>

    <div v-else-if="!hasNext" class="status-nomore">
      <slot name="noMore">
        <span>{{ $t('no-more-data') }}</span>
      </slot>
    </div>

    <div ref="bottomDom" />
  </div>
</template>
<script>
import Loading from 'com/Loading'
export default {
  name: 'LoadMore',
  components: {
    Loading
  },
  props: {
    elem: {
      type: window.Element
    },
    loadTrigger: {
      // Supposed to be Promised
      type: Function,
      default: () => Promise.resolve()
    }
  },
  data: () => ({
    scrollElem: window.document.body,
    list: [],
    error: null,
    isLoading: false,
    hasNext: true,
    isEmpty: false
  }),
  mounted() {
    this.scrollElem = this.elem || this.$el.parentNode
    this.scrollElem.addEventListener('scroll', this.handleScrollEvent, false)
    this.handleScrollEvent()
  },
  beforeDestroy() {
    this.scrollElem.removeEventListener('scroll', this.handleScrollEvent)
  },
  computed: {
    theme() {
      return this.$store.state.settings.theme
    }
  },
  methods: {
    reset() {
      this.isLoading = false
      this.hasNext = true
      this.isEmpty = false
      this.error = null
      this.list = []
      // next tick to apply changes
      this.$nextTick(() => {
        this.handleScrollEvent()
      })
    },
    handleScrollEvent() {
      if (this.isTimeToRefresh()) {
        this.refreshData().then(this.handleScrollEvent)
      }
    },
    isTimeToRefresh() {
      if (this.isLoading) return false
      if (!this.hasNext) return false
      if (this.isEmpty) return false
      // skip error check for retry loading
      // if (this.error) return false
      if (!this.$refs.bottomDom || !this.scrollElem) return false
      // check screen is full or not
      const bottomTop = this.$refs.bottomDom.getBoundingClientRect()
      const winRect = this.scrollElem.getBoundingClientRect()
      const hasRoom = bottomTop.top - winRect.bottom <= 5
      // prevent loop
      if (this.error && hasRoom) {
        return false
      }
      return hasRoom
    },
    refreshData() {
      this.isLoading = true
      return this.loadTrigger()
        .then(update => {
          if (Array.isArray(update)) {
            this.hasNext = this.list.length !== update.length
            this.list = update
            this.isEmpty = this.list.length === 0
          } else if (update) {
            this.hasNext = update.hasNext
            this.list = update.list
            this.isEmpty = update.list.length === 0
          }
        })
        .catch(err => {
          this.error = err
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';

.load-more {
  display: block;
  max-width: 100%;
}
.status-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  color: var(--active-color);
  font-weight: 500;
  .loading-text {
    margin-left: 10px;
  }
}
.status-nomore,
.status-empty {
  padding: 30px 0;
  text-align: center;
  color: @light-grey;
}
</style>
